<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div *ngIf="operation === 'mod-datos-pers'" class="pageTitle">
      {{ "maintenanceUsuario.titleEditDatPers" | translate }}
    </div>
    <div *ngIf="operation !== 'mod-datos-pers'" class="pageTitle">
      {{ "maintenanceUsuario.titleList" | translate }}
    </div>
    <div class="filterTableContainer">
      <app-filters
        #insideTable
        class="newFilters"
        [ngClass]="{ filterHidden: !showTableFilter }"
        *ngIf="perfilLoaded"
        [filterList]="filterList"
        [options]="options"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-table
        [tableList]="tableList"
        [elementList]="listUsers"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [routing]="routing"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons]="showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (elementsToRemove)="removeElements($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
        (downloadReportEvent)="downloadReport($event)"
      ></app-table>
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
    </div>
  </div>
</div>
